export default __webpack_public_path__ + "static/logo-gfk-1652def31e338bb97996300985669d4a.svg";